
import React, { Fragment, forwardRef, SVGAttributes } from 'react'

type PathProps = SVGAttributes<SVGPathElement>
type GroupProps = SVGAttributes<SVGGElement>

const ArrowDown = (props: PathProps) => (
  <path
    d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
    {...props}
  />
)
const Award = () => (
  <React.Fragment>
    <path
      d="M18.001 35.999a8.193 8.193 0 01-3.939-1.324c-.155-.084-.309-.168-.464-.25-.193-.008-.387-.014-.579-.021a6.449 6.449 0 01-6.745-3.91c-.1-.158-.2-.316-.294-.473-.155-.1-.311-.195-.467-.291a8.3 8.3 0 01-3.1-2.73 8.267 8.267 0 01-.816-4.018c-.006-.193-.013-.387-.021-.581-.085-.161-.173-.323-.261-.486a6.508 6.508 0 010-7.841c.087-.161.173-.32.258-.48.008-.193.015-.388.021-.581a6.451 6.451 0 013.912-6.744c.158-.1.316-.2.473-.294.11-.175.216-.35.322-.524a8.171 8.171 0 012.683-3.036 7.924 7.924 0 014.013-.823c.2-.007.4-.012.6-.021.153-.081.307-.165.461-.248a6.522 6.522 0 017.878 0l.468.252c.192.008.384.014.575.02a6.451 6.451 0 016.744 3.9c.1.16.2.321.3.479.158.1.317.2.477.3a6.45 6.45 0 013.907 6.736c.006.195.013.39.021.585.084.157.169.314.254.471a6.518 6.518 0 010 7.861c-.085.159-.172.318-.256.476-.008.195-.015.39-.021.584a6.453 6.453 0 01-3.911 6.739q-.238.146-.473.3c-.1.157-.2.316-.3.476a6.446 6.446 0 01-6.741 3.907c-.193.007-.386.013-.58.021-.156.083-.313.168-.471.254a8.193 8.193 0 01-3.928 1.315zM3.458 26.393a7.317 7.317 0 002.691 2.308c.2.123.4.246.6.372a.6.6 0 01.185.185c.127.2.251.4.375.6a5.316 5.316 0 005.752 3.335c.244.008.488.016.732.027a.6.6 0 01.252.068c.2.1.4.213.6.321a5.384 5.384 0 006.714 0c.2-.109.4-.219.607-.324a.6.6 0 01.252-.068c.244-.011.489-.02.732-.027a5.314 5.314 0 005.749-3.332c.125-.2.25-.4.378-.6a.609.609 0 01.185-.184c.2-.127.4-.252.6-.376a5.323 5.323 0 003.336-5.748c.008-.245.016-.492.028-.737a.611.611 0 01.068-.251c.107-.2.217-.407.327-.611a5.382 5.382 0 000-6.705c-.109-.2-.219-.4-.324-.605a.6.6 0 01-.068-.251c-.012-.245-.02-.492-.028-.737a5.319 5.319 0 00-3.333-5.746c-.2-.125-.405-.25-.605-.378a.6.6 0 01-.184-.185c-.129-.2-.254-.4-.38-.609a5.317 5.317 0 00-5.751-3.328c-.242-.008-.485-.015-.727-.027a.611.611 0 01-.253-.068c-.2-.1-.4-.214-.6-.323a5.388 5.388 0 00-6.721 0c-.2.108-.4.215-.595.32a.614.614 0 01-.253.068c-.25.012-.5.019-.754.027a5.29 5.29 0 00-5.7 3.28c-.133.218-.267.438-.407.656a.6.6 0 01-.185.185c-.2.127-.4.252-.6.376a5.32 5.32 0 00-3.337 5.751c-.008.245-.016.489-.028.733a.6.6 0 01-.068.251c-.107.205-.218.41-.329.616a5.37 5.37 0 000 6.686c.112.207.224.414.332.621a.592.592 0 01.068.251c.012.244.02.488.028.732a7.268 7.268 0 00.652 3.448zm14.543 3.521A11.914 11.914 0 1129.915 18a11.928 11.928 0 01-11.914 11.91zm0-22.615a10.7 10.7 0 1010.7 10.7 10.714 10.714 0 00-10.7-10.701z"
      fill="#0c0636"
    />
    <path
      d="M22.456 25.004a.612.612 0 01-.282-.069l-4.173-2.192-4.174 2.192a.606.606 0 01-.879-.64l.8-4.645-3.376-3.291a.606.606 0 01.336-1.034l4.667-.679 2.086-4.227a.63.63 0 011.087 0l2.088 4.228 4.666.678a.606.606 0 01.336 1.034l-3.377 3.291.8 4.645a.606.606 0 01-.6.709zm-10.362-8.656l2.725 2.657a.607.607 0 01.174.536l-.643 3.749 3.369-1.77a.61.61 0 01.564 0l3.368 1.77-.643-3.749a.6.6 0 01.174-.536l2.725-2.657-3.765-.547a.6.6 0 01-.457-.332l-1.684-3.413-1.685 3.411a.6.6 0 01-.457.332z"
      fill="#068484"
    />
  </React.Fragment>
)

const Bars = (props: PathProps) => (
  <path
    d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
    {...props}
  />
)

const Calendar = (props: PathProps) => (
  <path
    d="M9 4v1H5v22h22V5h-4V4h-2v1H11V4H9zM7 7h2v1h2V7h10v1h2V7h2v2H7V7zm0 4h18v14H7V11zm6 2v2h2v-2h-2zm4 0v2h2v-2h-2zm4 0v2h2v-2h-2zM9 17v2h2v-2H9zm4 0v2h2v-2h-2zm4 0v2h2v-2h-2zm4 0v2h2v-2h-2zM9 21v2h2v-2H9zm4 0v2h2v-2h-2zm4 0v2h2v-2h-2z"
    {...props}
  />
)

const Camera = (props: PathProps) => (
  <path
    d="M11.5 6l-.31.4L10 8H9V7H5v1H3v18h26V8h-7l-1.19-1.6-.31-.4h-9zm1 2h7l1.19 1.6.31.4h6v4h-5.81A6.02 6.02 0 0 0 16 11a6.02 6.02 0 0 0-5.19 3H5v-4h6l.31-.4L12.5 8zM23 11v2h2v-2h-2zm-7 2c2.22 0 4 1.78 4 4 0 2.22-1.78 4-4 4-2.22 0-4-1.78-4-4 0-2.22 1.78-4 4-4zM5 16h5.1a6.02 6.02 0 0 0 5.9 7 6.02 6.02 0 0 0 5.9-7H27v8H5v-8z"
    {...props}
  />
)

const CaretDown = (props: PathProps) => (
  <path
    d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
    {...props}
  />
)

const Clap = () => (
  <React.Fragment>
    <defs />
    <path
      d="M15.672 14.944a1.294 1.294 0 001.6-1.807l-5.984-5.791A1.57737258 1.57737258 0 009.199 9.71zM21.481 9.863a1.108 1.108 0 001.4.414c.606-.2 1.009-.713.893-1.163l-2.234-8.02a1.57831587 1.57831587 0 10-3 .982zM2.949 19.057a1.524 1.524 0 001.332 1.787l8.283.84c.466.039.9-.442.993-1.076a1.1 1.1 0 00-.645-1.313l-8.175-1.57a1.522 1.522 0 00-1.788 1.332z"
      sx={{ fill: '#6c3' }}
    />
    <path d="M48.598 50.682l.3 1.732c.089.519.144 1.03.2 1.542 2.48-2.2 4.752-5.572 6.715-10.743a24.451 24.451 0 015.6-8.8c1.224-1.31 2.614-2.792 1.909-4.818-.75-2.139-3.357-3.685-6.2-3.685a7.97 7.97 0 00-1.816.21 8.528 8.528 0 00-3.222 1.544l-.08-11.635a5.532 5.532 0 00-5.5-5.522 6.377 6.377 0 00-2.5.559 5.544 5.544 0 00-9.818-1.272 5.825 5.825 0 00-3.129-.879 5.6 5.6 0 00-5.472 5.724 5.919 5.919 0 00-1.874-.337 5.026 5.026 0 00-3.627 1.528 5.4 5.4 0 00-1.59 3.8v.523a7.735 7.735 0 011.385-.4 8.264 8.264 0 011.281-.125 2.651 2.651 0 012.55-2.651 2.736 2.736 0 012.716 2.614v.68l1.857-.384-.038-5.385a2.865 2.865 0 012.872-2.912 2.93 2.93 0 012.918 2.872l.048 7.035a8.166 8.166 0 011.87 2.027l-.073-10.569a2.89408362 2.89408362 0 015.788-.044l.084 12.351a8.163 8.163 0 011.871 1.811l-.075-10.974a2.89307622 2.89307622 0 115.786-.042l.131 19.379a19.18 19.18 0 001.8-2.677c1.372-2.5 3.066-3.66 4.648-4.033a5.3 5.3 0 011.205-.14c1.857 0 3.364.99 3.681 1.892.464 1.336-4.292 3.385-7.484 11.8a26.989 26.989 0 01-4.717 8.404z" />
    <path d="M.066 48.543c-.427 2.107 1.285 3.339 2.72 4.413a24.5 24.5 0 017.054 7.693c4.827 8.083 10.04 11.689 16.9 11.689a34.249 34.249 0 005.292-.5 17.49 17.49 0 0011.751-6.729 15.918 15.918 0 002.478-12.245l-3.8-21.956a5.332 5.332 0 00-6.2-4.313 5.355 5.355 0 01-8.041-4.046 5.181 5.181 0 00-2.931 1.414 5.478 5.478 0 00-4.94-1.591 5.6 5.6 0 00-4.5 4.551 6.084 6.084 0 00-2.421-.129 5.206 5.206 0 00-3.574 2.17 5.768 5.768 0 00-1.021 4.251l1.955 11.473C8.246 42.859 1.119 43.321.066 48.543zm6.01-2.095c2.766-.577 4.872 1.347 6.409 3.1a25.866 25.866 0 002.241 2.322l-3.256-19.1a2.907 2.907 0 012.366-3.335 2.811 2.811 0 013.34 2.365l2.613 15.334a14.68 14.68 0 011.694-1.122L18.47 28.336a2.89500022 2.89500022 0 015.708-.971l2.83 16.629a12.893 12.893 0 011.841-.26l-2.594-15.206a2.89500022 2.89500022 0 015.708-.971l2.847 16.706a14.56 14.56 0 012.005.706L34.65 32.248a2.685 2.685 0 012.152-3.036 2.581 2.581 0 013.037 2.153l3.8 21.949c1.574 9.229-4.448 14.709-12.01 15.891a31.893 31.893 0 01-4.88.47c-4.878 0-9.575-1.951-14.614-10.392-4.616-7.729-9.656-8.912-9.432-10.309.153-.964 1.516-2.136 3.374-2.523z" />
  </React.Fragment>
)

const Check = (props: PathProps) => (
  <path
    d="M51.55,39.072a41.766,41.766,0,0,0-4.857,8.749,13.063,13.063,0,0,0-1.785-2.616c-.442-.48-2.426-.176-1.781.524a20.971,20.971,0,0,1,2.742,4.621c.252.489,1.8.59,1.989,0a40.811,40.811,0,0,1,5.681-11C53.948,38.782,51.967,38.494,51.55,39.072Z"
    {...props}
  />
)

const CheckMark = (props: GroupProps) => (
  <g transform="translate(0.761 0.749)" {...props}>
    <g transform="translate(1.331 0.325)">
      <path
        d="M614.6,261.694,610.357,266c-.068.069-.143.135-.217.2l-.066.059a1.277,1.277,0,0,1-.868.316h-.015a1.276,1.276,0,0,1-.87-.34l-.08-.076-.009-.009c-.068-.063-.124-.119-.184-.176l-1.381-1.358c-.988-.971-2.106-2.071-3.2-3.14a2.414,2.414,0,0,0-1.662-.7,1.9,1.9,0,0,0-.616.1c-.629.188-.62.062-.794.605-.148.552.339.819.794,1.235,2.388,2.385,4.065,5.68,6.76,8.283a2.21,2.21,0,0,0,.808.463,2.5,2.5,0,0,0,.772.129,2.032,2.032,0,0,0,1.644-.838h0l3.278-4.292.158-.2.091-.12c3.265-4.272,12.366-17.646,11.594-18.3-1.089-.917-8.432,10.551-11.526,13.692Z"
        transform="translate(-600.364 -247.788)"
      />
    </g>
    <path
      sx={{
        fill: 'none',
        stroke: 'brand.red',
        strokeWidth: '1.5px',
      }}
      d="M616.024,265.241l-4.656,5.613c-.074.09-.157.176-.238.26l-.072.076a1.277,1.277,0,0,1-.951.412h-.017a1.287,1.287,0,0,1-.953-.443l-.088-.1-.01-.012c-.074-.082-.136-.155-.2-.229l-1.514-1.769c-1.083-1.265-2.309-2.7-3.513-4.09a2.465,2.465,0,0,0-1.822-.918,1.789,1.789,0,0,0-.676.13,2.156,2.156,0,0,0-.87,3.537c2.618,3.106,5.327,6.258,8.281,9.648a2.43,2.43,0,0,0,1.732.771,3.083,3.083,0,0,0,2.245-1.212c1.7-2.547,2.533-3.94,4.25-6.344,0-.006,10.938-15.188,10.094-15.969-1.194-1.194-7.456,6.335-10.848,10.425Z"
      transform="translate(-599.852 -254.478)"
    />
  </g>
)

const ChevronDown = (props: PathProps) => (
  <path
    d="M3.388,7.5l5.1-5.1a1.4,1.4,0,0,0,0-1.985h0a1.4,1.4,0,0,0-1.984,0l-6.1,6.1h0a1.4,1.4,0,0,0,0,1.985l6.1,6.1a1.4,1.4,0,0,0,1.984,0h0a1.4,1.4,0,0,0,0-1.985Z"
    transform="translate(0 8.904) rotate(-90)"
    {...props}
  />
)

const ChevronRight = (props: PathProps) => (
  <path
    d="M1.818 0L-.001 1.817l5.895 5.895-5.893 5.893 1.819 1.819 7.712-7.712z"
    {...props}
  />
)

const ChevronUp = (props: PathProps) => (
  <path
    d="M3.388,7.5l5.1-5.1a1.4,1.4,0,0,0,0-1.985h0a1.4,1.4,0,0,0-1.984,0l-6.1,6.1h0a1.4,1.4,0,0,0,0,1.985l6.1,6.1a1.4,1.4,0,0,0,1.984,0h0a1.4,1.4,0,0,0,0-1.985Z"
    transform="translate(0 8.904) rotate(90)"
    {...props}
  />
)
const Clock = () => (
  <React.Fragment>
    <defs />
    <path
      d="M28.949 17.213h2.578v1.569h-2.578zM4.474 17.213h2.578v1.569H4.474zM17.216 29.548h1.569v2.579h-1.569zM17.216 3.871h1.569V6.45h-1.569z"
      sx={{ fill: '#0c0636' }}
    />
    <path
      fill="#059b9a"
      d="M18.001 10.007a.785.785 0 00-.784.784v6.883l-6.019 6.02a.785.785 0 000 1.109.777.777 0 00.554.23.777.777 0 00.555-.23l6.25-6.25a.775.775 0 00.229-.554v-7.208a.785.785 0 00-.785-.784z"
    />
    <path
      d="M31.777.773a.785.785 0 00-.508-.678.786.786 0 00-.828.18l-2.635 2.636A17.986 17.986 0 0015.784.139a17.877 17.877 0 00-11.98 6.8A17.883 17.883 0 00.141 20.22a17.956 17.956 0 001.843 6l.072.139 1.4-.715-.071-.139a16.4 16.4 0 01-1.683-5.478A16.325 16.325 0 015.047 7.904a16.319 16.319 0 0110.936-6.207 16.456 16.456 0 0110.7 2.349l-2.485 2.486a.784.784 0 00-.179.832.785.785 0 00.684.506l6.731.42h.05a.787.787 0 00.557-.232.779.779 0 00.225-.609zm-1.149 5.894l-4.1-.257 3.81-3.811zM35.861 15.781a17.847 17.847 0 00-1.932-6.172l-.073-.139-1.388.732.073.139a16.307 16.307 0 011.763 5.632 16.449 16.449 0 01-14.281 18.329 16.436 16.436 0 01-10.852-2.448l2.448-2.447a.787.787 0 00.181-.83.79.79 0 00-.68-.508l-6.677-.478a.812.812 0 00-.606.225.785.785 0 00-.231.606l.421 6.731a.786.786 0 00.506.685.793.793 0 00.832-.179l2.682-2.681a17.875 17.875 0 009.934 3.018 18.108 18.108 0 002.235-.139 18.018 18.018 0 0015.645-20.076zM9.297 29.511l-3.812 3.81-.256-4.1z"
      sx={{ fill: '#0c0636' }}
    />
  </React.Fragment>
)
const Comments = (props: PathProps) => (
  <path
    d="M2 5v16h4v5.1l1.63-1.32L12.34 21H22V5H2zm2 2h16v12h-8.34l-.29.22L8 21.9V19H4V7zm20 2v2h4v12h-4v2.9L20.34 23h-7.5l-2.5 2h9.32L26 30.1V25h4V9h-6z"
    {...props}
  />
)

const Envelope = (props: PathProps) => (
  <path
    d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
    {...props}
  />
)

const ExclamationCircle = (props: PathProps) => (
  <path
    d="M 16 4 C 9.3844277 4 4 9.3844277 4 16 C 4 22.615572 9.3844277 28 16 28 C 22.615572 28 28 22.615572 28 16 C 28 9.3844277 22.615572 4 16 4 z M 16 6 C 21.534692 6 26 10.465308 26 16 C 26 21.534692 21.534692 26 16 26 C 10.465308 26 6 21.534692 6 16 C 6 10.465308 10.465308 6 16 6 z M 15 10 L 15 18 L 17 18 L 17 10 L 15 10 z M 15 20 L 15 22 L 17 22 L 17 20 L 15 20 z"
    {...props}
  />
)

const ExternalLinkAlt = (props: PathProps) => (
  <path
    d="M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"
    {...props}
  />
)

const Expand = (props: PathProps) => (
  <path
    d="M14 5v2h9.56L7 23.56V14H5v13h13v-2H8.44L25 8.44V18h2V5H14z"
    {...props}
  />
)

const Eye = (props: PathProps) => (
  <path
    d="M16 8C7.66 8 1.25 15.34 1.25 15.34l-.6.66.6.66s5.85 6.66 13.63 7.28a8.88 8.88 0 0 0 2.24 0c7.78-.62 13.63-7.28 13.63-7.28l.6-.66-.6-.66S24.34 8 16 8zm0 2c2.2 0 4.23.6 6 1.4a7 7 0 0 1-5.22 10.56h-.06c-.24.02-.48.04-.72.04l-.78-.03a7 7 0 0 1-5.25-10.53h-.03A14.52 14.52 0 0 1 16 10zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-8.75.94a8.93 8.93 0 0 0 1.13 6.84A23.1 23.1 0 0 1 3.53 16c.48-.5 1.82-1.8 3.72-3.06zm17.5 0A24.06 24.06 0 0 1 28.47 16a23.1 23.1 0 0 1-4.84 3.78 8.94 8.94 0 0 0 1.12-6.84z"
    {...props}
  />
)

const EyeSlash = (props: PathProps) => (
  <path
    d="M 3.71875 2.28125 L 2.28125 3.71875 L 8.46875 9.875 L 10 11.40625 L 13.0625 14.46875 L 16.53125 17.9375 L 19.59375 21 L 21.4375 22.84375 L 28.28125 29.71875 L 29.71875 28.28125 L 23.375 21.9375 C 27.472167 19.853342 30.526114 16.910518 30.71875 16.71875 L 31.375 16.0625 L 30.75 15.34375 C 30.494 15.04375 24.395 8 16 8 C 14.006995 8 12.153739 8.4191302 10.46875 9.03125 L 3.71875 2.28125 z M 16 10 C 18.164 10 20.1615 10.55575 21.9375 11.34375 C 22.6145 12.44375 23 13.7 23 15 C 23 16.814903 22.300102 18.470218 21.15625 19.71875 L 18.3125 16.875 C 18.727333 16.361769 19 15.710443 19 15 C 19 13.346 17.654 12 16 12 C 15.289557 12 14.638231 12.272667 14.125 12.6875 L 12.0625 10.625 C 13.302612 10.254073 14.611291 10 16 10 z M 6.625 10.875 C 3.387 12.865 1.394 15.17375 1.25 15.34375 L 0.625 16.0625 L 1.28125 16.71875 C 1.56725 17.00375 8.0985 23.3825 15.0625 23.9375 L 15.125 23.9375 C 15.415 23.9625 15.71 24 16 24 C 16.29 24 16.585 23.9625 16.875 23.9375 L 16.9375 23.9375 C 17.7355 23.8745 18.5345 23.72925 19.3125 23.53125 L 17.59375 21.8125 C 17.34375 21.8695 17.0735 21.9085 16.8125 21.9375 L 16.6875 21.96875 C 16.2205 22.00775 15.7785 22.00775 15.3125 21.96875 L 15.21875 21.9375 C 11.67975 21.5395 9 18.565 9 15 C 9 14.464 9.0665 13.9505 9.1875 13.4375 L 6.625 10.875 z M 7.28125 12.84375 C 7.10725 13.54775 7 14.263 7 15 C 7 16.612 7.4375 18.1215 8.1875 19.4375 C 6.0655 18.1755 4.32025 16.7485 3.40625 15.9375 C 4.15125 15.1945 5.50625 13.98975 7.28125 12.84375 z M 24.71875 12.84375 C 26.49075 13.98875 27.8175 15.22675 28.5625 15.96875 C 27.6485 16.77975 25.9355 18.1755 23.8125 19.4375 C 24.5625 18.1205 25 16.614 25 15 C 25 14.265 24.89175 13.54575 24.71875 12.84375 z M 16 14 C 16.552 14 17 14.449 17 15 C 17 15.162317 16.943962 15.301757 16.875 15.4375 L 15.5625 14.125 C 15.698267 14.055942 15.837389 14 16 14 z"
    {...props}
  />
)

const FacebookSquare = (props: PathProps) => (
  <path
    d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"
    {...props}
  />
)

const File = (props: PathProps) => (
  <path
    d="M6 3v26h20V9.594l-.281-.313-6-6L19.406 3H6zm2 2h10v6h6v16H8V5zm12 1.438L22.563 9H20V6.437z"
    {...props}
  />
)

const FilePdf = (props: PathProps) => (
  <path
    d="M6 3v26h20V3H6zm2 2h16v22H8V5zm7.406 5.344a1.428 1.428 0 00-.906.312c-.254.215-.369.482-.438.75-.137.538-.097 1.099.032 1.719.15.726.587 1.6.937 2.438-.18.763-.225 1.435-.5 2.218-.236.673-.536 1.059-.812 1.657-.63.237-1.38.379-1.875.687-.534.332-1.002.7-1.281 1.219-.28.518-.248 1.252.124 1.781a1.6 1.6 0 00.75.625c.324.128.675.133.97.031.588-.203 1.006-.656 1.405-1.187.37-.492.635-1.328.97-2 .504-.168.868-.38 1.405-.5.564-.126.94-.065 1.47-.125.227.259.419.67.655.875.477.413 1 .743 1.625.781.626.038 1.25-.352 1.594-.938h.032v-.03c.151-.268.256-.554.25-.876-.007-.322-.17-.655-.375-.875-.411-.44-.934-.55-1.5-.625-.436-.057-1.046.099-1.563.125-.452-.596-.903-1.046-1.313-1.812-.22-.414-.282-.767-.468-1.188.143-.679.43-1.436.468-2.031.048-.718.02-1.339-.187-1.906a1.828 1.828 0 00-.531-.781 1.481 1.481 0 00-.907-.344h-.03zm.656 7.406c.181.316.402.517.594.813-.282.05-.496-.002-.781.062-.048.01-.077.051-.125.063.057-.155.132-.25.188-.407.064-.183.064-.347.124-.531zm3.688 2.031c.337.044.455.106.5.125-.007.016.012.01 0 .032-.123.205-.139.192-.219.187-.067-.004-.32-.142-.562-.313.07.006.217-.04.281-.03zm-7 1.563c-.055.081-.102.272-.156.343-.305.406-.586.596-.656.625-.013-.013.02-.001 0-.03h-.032c-.103-.147-.072-.085 0-.22.073-.134.31-.402.719-.656.03-.018.094-.044.125-.062z"
    {...props}
  />
)

const FileSigned = (props: PathProps) => (
  <path
    d="M6 3v26h20V9.6l-.3-.3-6-6-.3-.3H6zm2 2h10v6h6v16H8V5zm12 1.4L22.6 9H20V6.4zM10 13v2h12v-2H10zm3.5 3c-.9 0-1.6.6-2 1.3-.4.7-.5 1.6-.5 2.6 0 .6.2 1.2.3 1.8-.4.1-.8.4-1.3.4v2c.7 0 1.4-.1 2-.3.1.2.1.3.3.5.4.4 1 .7 1.7.7 1.6 0 2.6-1.1 3.3-1.9.1-.2.2-.3.3-.4 0 .1 0 .2.1.3.1.2.2.4.4.6.2.2.6.4.9.4.6 0 1-.4 1.2-.6.2-.2.4-.5.6-.7.4-.4.7-.7 1.1-.7v-2c-1.2 0-2.1.7-2.6 1.3 0-.1 0-.2-.1-.3-.1-.2-.2-.4-.4-.7-.2-.3-.5-.3-.8-.3-.8 0-1.1.5-1.4.8-.3.3-.6.7-.8 1.1-.6.7-1 1.1-1.8 1.1-.1 0-.1-.1-.2-.1.1 0 .1-.1.2-.1 1.1-.9 2-2.1 2-3.7 0-.8-.2-1.5-.6-2.1-.4-.6-1.1-1-1.9-1zm-.1 2c.3 0 .3 0 .4.2.1.2.2.5.2 1 0 .6-.3 1.2-.8 1.7 0-.3-.2-.7-.2-.9 0-.8.1-1.4.3-1.7.1-.2.1-.3.1-.3z"
    {...props}
  />
)

const FileText = (props: PathProps) => (
  <path
    d="M6 3v26h20V9.594l-.281-.313-6-6L19.406 3H6zm2 2h10v6h6v16H8V5zm12 1.438L22.563 9H20V6.437zM11 13v2h10v-2H11zm0 4v2h10v-2H11zm0 4v2h10v-2H11z"
    {...props}
  />
)

const FindAStore = () => (
  <React.Fragment>
    <path
      d="M18.503 48.295a2.531 2.531 0 01-1.972-.937c-.5-.7-11.424-15.9-14.548-20.844A15.038 15.038 0 010 18.295a18.5 18.5 0 0137 0 15.049 15.049 0 01-1.98 8.219c-3.125 4.942-14.048 20.146-14.511 20.791a2.541 2.541 0 01-2.006.99zm0-46.139A16.25 16.25 0 002.18 18.295a13.022 13.022 0 001.651 7.075c3.091 4.89 14.324 20.528 14.437 20.687a.418.418 0 00.5-.047c.08-.112 11.315-15.752 14.406-20.64a13.022 13.022 0 001.647-7.075A16.247 16.247 0 0018.503 2.156z"
      fill="#fff"
    />
    <path
      d="M18.5 25.396a8.007 8.007 0 118.1-8.007 8.061 8.061 0 01-8.1 8.007zm0-13.858a5.851 5.851 0 105.917 5.851 5.891 5.891 0 00-5.917-5.851z"
      fill="#9fd96b"
    />
    <path
      d="M35.91 50H1.09a1.078 1.078 0 110-2.156h34.82a1.078 1.078 0 110 2.156z"
      fill="#fff"
    />
  </React.Fragment>
)

const FindMe = (props: PathProps) => (
  <React.Fragment>
    <path
      d="M330,158h-22.53C301.71,92.01,248.99,39.29,183,33.53V12c0-6.62-5.38-12-12-12s-12,5.38-12,12v21.53
      C93.01,39.29,40.29,92.01,34.53,158H12c-6.62,0-12,5.38-12,12s5.38,12,12,12h22.53C40.29,247.99,93.01,300.71,159,306.47V330
      c0,6.62,5.38,12,12,12s12-5.38,12-12v-23.53c65.99-5.75,118.71-58.48,124.47-124.47H330c6.62,0,12-5.38,12-12S336.62,158,330,158z
      M171,92c6.62,0,12-5.38,12-12V57.64c52.74,5.59,94.77,47.62,100.36,100.36H262c-6.62,0-12,5.38-12,12s5.38,12,12,12h21.36
      c-5.59,52.74-47.62,94.77-100.36,100.36V262c0-6.62-5.38-12-12-12s-12,5.38-12,12v20.36C106.26,276.77,64.23,234.74,58.64,182H80
      c6.62,0,12-5.38,12-12s-5.38-12-12-12H58.64C64.23,105.26,106.26,63.23,159,57.64V80C159,86.62,164.38,92,171,92z"
      {...props}
    />
    <path
      d="M171,189L171,189c-9.94,0-18-8.06-18-18v0c0-9.94,8.06-18,18-18h0c9.94,0,18,8.06,18,18v0C189,180.94,180.94,189,171,189z"
      {...props}
    />
  </React.Fragment>
)

const FiveMillion = (props: PathProps) => (
  <React.Fragment>
    <g transform="translate(-2665.701 73.139)">
      <path
        d="M2696.47-45.933a24.148,24.148,0,0,1,12.281,3.158,21.843,21.843,0,0,1,8.529,8.934,28.138,28.138,0,0,1,3.05,13.333q0,13.225-7.962,20.3t-24.1,7.071q-13.82,0-22.564-4.265v-17.49a56.718,56.718,0,0,0,10.607,3.563,45.052,45.052,0,0,0,10.176,1.4q5.937,0,9.122-2.51t3.185-7.423a8.479,8.479,0,0,0-3.239-7.071q-3.24-2.536-9.825-2.537a35.327,35.327,0,0,0-10.851,1.89l-7.827-3.887,2.969-41.673h50.223v17.76h-32.086l-.971,10.418a48.207,48.207,0,0,1,5.991-.89Q2694.959-45.933,2696.47-45.933Z"
        {...props}
      />
      <g transform="translate(2723.229 -73.139)">
        <path
          d="M2720.886-67.357l9.557-2.714v-.083q-2.441.191-3.794.191h-5.763v-3.177h13.269v4.774l-9.421,2.768v.073l9.421,2.714v4.783h-13.269v-3.3h5.817c.3,0,.639.005,1.008.014s1.274.05,2.714.123v-.082l-9.539-2.678Z"
          transform="translate(-2720.704 73.139)"
          {...props}
        />
        <path
          d="M2720.886-55.954h13.269v3.6h-13.269Z"
          transform="translate(-2720.704 73.925)"
          {...props}
        />
        <path
          d="M2720.886-49.765h13.269v3.585h-10.374v5.11h-2.9Z"
          transform="translate(-2720.704 74.208)"
          {...props}
        />
        <path
          d="M2720.886-39.42h13.269v3.586h-10.374v5.11h-2.9Z"
          transform="translate(-2720.704 74.682)"
          {...props}
        />
        <path
          d="M2720.886-29.074h13.269v3.6h-13.269Z"
          transform="translate(-2720.704 75.155)"
          {...props}
        />
        <path
          d="M2727.547-10.447a7.159,7.159,0,0,1-5.092-1.643,6.3,6.3,0,0,1-1.743-4.81,6.3,6.3,0,0,1,1.751-4.787,7.129,7.129,0,0,1,5.1-1.666,7.082,7.082,0,0,1,5.061,1.656,6.322,6.322,0,0,1,1.747,4.815,6.289,6.289,0,0,1-1.734,4.8A7.164,7.164,0,0,1,2727.547-10.447Zm0-9.132q-3.85,0-3.848,2.678a2.3,2.3,0,0,0,.935,2.019,5.117,5.117,0,0,0,2.914.658,5.151,5.151,0,0,0,2.936-.667,2.277,2.277,0,0,0,.948-1.992Q2731.432-19.578,2727.547-19.579Z"
          transform="translate(-2720.712 75.417)"
          {...props}
        />
        <path
          d="M2720.886,3.914v-4.7l9.349-4.847v-.082q-2.206.173-3.367.173h-5.982V-8.721h13.269v4.684L2724.934.791V.846q2.006-.127,3.222-.127h6V3.914Z"
          transform="translate(-2720.704 76.086)"
          {...props}
        />
      </g>
    </g>
  </React.Fragment>
)

const Frown = (props: PathProps) => (
  <path
    d="M16 4C9.38 4 4 9.38 4 16s5.38 12 12 12 12-5.38 12-12S22.62 4 16 4zm0 2c5.53 0 10 4.47 10 10s-4.47 10-10 10S6 21.53 6 16 10.47 6 16 6zm-4.5 6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm9 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM16 18a7.98 7.98 0 0 0-6.47 3.34l1.63 1.16a5.94 5.94 0 0 1 9.68 0l1.63-1.16A7.98 7.98 0 0 0 16 18z"
    {...props}
  />
)

const GetMoreCash = (props: GroupProps) => (
  <React.Fragment>
    <g {...props}>
      <path d="M18.499 19.691a9.518 9.518 0 01-4.664-1.166 3.8 3.8 0 01-2.2-3.1 3.126 3.126 0 011.774-2.663 9.375 9.375 0 018.605.227 3.8 3.8 0 012.2 3.1 3.13 3.13 0 01-1.776 2.667 7.955 7.955 0 01-3.939.935zm-1.16-6.5a6.621 6.621 0 00-3.247.743 1.847 1.847 0 00-1.1 1.485c0 .666.555 1.367 1.521 1.924a8.136 8.136 0 007.239.232 1.851 1.851 0 001.1-1.489c0-.666-.554-1.367-1.519-1.923a8.234 8.234 0 00-3.99-.968z" />
      <path
        d="M22.581 3.525a.68.68 0 01-.68-.68V.679a.68.68 0 01.68-.68.68.68 0 01.68.68v2.166a.68.68 0 01-.68.68zM17.453 5.577a.678.678 0 01-.481-.2L15.44 3.845a.68.68 0 010-.961.68.68 0 01.961 0l1.532 1.533a.68.68 0 010 .961.679.679 0 01-.48.199zM27.711 5.577a.681.681 0 01-.48-.2.679.679 0 010-.961l1.532-1.533a.679.679 0 01.961 0 .679.679 0 010 .961l-1.531 1.532a.677.677 0 01-.482.201z"
        sx={{
          fill: '#059b9a',
        }}
      />
      <path d="M13.418 26.324a.676.676 0 01-.335-.089L.345 19.009a.68.68 0 01-.344-.59.68.68 0 01.342-.59l21.9-12.546a.68.68 0 01.673 0l12.738 7.226a.68.68 0 01.343.59.679.679 0 01-.341.591l-21.9 12.547a.679.679 0 01-.338.087zM2.053 18.416l11.364 6.446 20.531-11.761-11.364-6.447z" />
      <path d="M13.418 28.828a.682.682 0 01-.336-.089L.344 21.513a.681.681 0 01-.255-.927.681.681 0 01.927-.256l12.4 7.035 21.566-12.354a.68.68 0 01.927.252.679.679 0 01-.252.927l-21.9 12.546a.679.679 0 01-.339.092z" />
      <path d="M13.418 31.242a.676.676 0 01-.336-.089L.344 23.927A.681.681 0 01.089 23a.681.681 0 01.927-.256l12.4 7.035 21.566-12.354a.68.68 0 01.927.252.679.679 0 01-.252.927l-21.9 12.546a.674.674 0 01-.339.092z" />
      <path d="M13.418 33.662a.683.683 0 01-.335-.088L.345 26.348a.683.683 0 01-.344-.592v-7.338a.68.68 0 01.68-.68.68.68 0 01.68.68v6.942l12.057 6.839 21.224-12.158v-6.944a.68.68 0 01.68-.68.679.679 0 01.68.68v7.338a.679.679 0 01-.341.589l-21.9 12.547a.678.678 0 01-.343.091z" />
      <path d="M3.247 20.544v-1.359c.8 0 1.39-.41 1.39-.777s-.595-.779-1.39-.779V16.27c1.542 0 2.75.939 2.75 2.138s-1.208 2.136-2.75 2.136zM32.778 15.248c-1.542 0-2.75-.938-2.75-2.136s1.208-2.137 2.75-2.137v1.359c-.8 0-1.39.411-1.39.778s.595.777 1.39.777zM16.502 24.236h-1.359c0-.15-.613-.6-1.729-.6s-1.728.451-1.728.6h-1.359c0-1.117 1.328-1.96 3.087-1.96s3.088.843 3.088 1.96zM22.611 9.203c-1.76 0-3.087-.843-3.087-1.961h1.359c0 .15.613.6 1.728.6s1.729-.452 1.729-.6h1.359c.001 1.118-1.327 1.961-3.088 1.961z" />
    </g>
  </React.Fragment>
)

const Heart = (props: GroupProps) => (
  <path
    d="M791.1,653.483a16.661,16.661,0,0,1-1.113,5.874,36.5,36.5,0,0,1-4.16,8.155,45.782,45.782,0,0,1-2.958,3.791q-1.968,2.354-4.026,4.633c-3.034,3.351-6.241,6.531-9.551,9.609-1.47,1.366-2.973,2.7-4.452,4.052-.22.2-.363.239-.6.017-1.717-1.579-3.474-3.114-5.165-4.718q-3.063-2.9-6.036-5.9a92.96,92.96,0,0,1-7.825-8.948,43.786,43.786,0,0,1-5.129-8.22,18.245,18.245,0,0,1-1.815-8.927,12.344,12.344,0,0,1,2.4-6.679,11.768,11.768,0,0,1,4.937-3.815,15.4,15.4,0,0,1,6.781-1.307,11.981,11.981,0,0,1,5.432,1.433,13,13,0,0,1,2.4,1.85,20.637,20.637,0,0,1,4.067,5.506c.028.052.056.1.086.154.15.248.264.25.417-.007.191-.32.371-.649.564-.968a21.48,21.48,0,0,1,4.066-5.07,9.505,9.505,0,0,1,4.257-2.252c.69-.154,1.373-.35,2.067-.478a12.171,12.171,0,0,1,3.561-.052,15.189,15.189,0,0,1,6.524,2.264,11.082,11.082,0,0,1,4.8,6.53A13.961,13.961,0,0,1,791.1,653.483Z"
    transform="translate(-738.234 -641.086)"
    {...props}
  />
)

const HelpCenterChevron = (props: GroupProps) => (
  <g {...props}>
    <circle cx="24.5" cy="24.5" r="15" sx={{ fill: '#fff' }} />
    <circle
      sx={{
        fill: 'none',
        stroke: '#0c0636',
        strokeMiterlimit: 10,
        strokeWidth: 2,
      }}
      cx="24.5"
      cy="24.5"
      r="15"
    />
    <path
      sx={{
        strokeMiterlimit: 10,
      }}
      d="M32.5 22.19a2.92 2.92 0 01-.56.71l-6.61 6.6c-.62.62-1 .62-1.66 0q-3.41-3.39-6.81-6.81a.92.92 0 01.23-1.59.94.94 0 011.08.3c1.63 1.64 3.27 3.27 4.9 4.9.41.41.83.81 1.23 1.24.16.16.24.16.4 0l6.12-6.14a1 1 0 011-.34 1.05 1.05 0 01.69.7z"
    />
  </g>
)

const Home = (props: PathProps) => (
  <path
    d="M 16 2.59375 L 15.28125 3.28125 L 2.28125 16.28125 L 3.71875 17.71875 L 5 16.4375 L 5 27 L 5 28 L 6 28 L 13 28 L 14 28 L 14 27 L 14 18 L 18 18 L 18 27 L 18 28 L 19 28 L 26 28 L 27 28 L 27 27 L 27 16.4375 L 28.28125 17.71875 L 29.71875 16.28125 L 16.71875 3.28125 L 16 2.59375 z M 16 5.4375 L 25 14.4375 L 25 26 L 20 26 L 20 17 L 20 16 L 19 16 L 13 16 L 12 16 L 12 17 L 12 26 L 7 26 L 7 14.4375 L 16 5.4375 z"
    {...props}
  />
)

const IdCard = (props: PathProps) => {
  return (
    <path
      d="M29.33 3.11H2.67A2.67 2.67 0 0 0 0 5.78v19.55C0 26.81 1.2 28 2.67 28h26.66c1.48 0 2.67-1.2 2.67-2.67V5.78c0-1.47-1.2-2.67-2.67-2.67zM30 26H17v-2c0-1.77-1.94-3-4-3-.6 0-1.05.5-2.5.5C9 21.5 8.63 21 8 21c-2.06 0-4 1.32-4 3.09V26H2V8h28v18zM20 14h7v-2h-7v2zm-9.5 5c1.96 0 3.5-1.54 3.5-3.5S12.46 12 10.5 12A3.46 3.46 0 0 0 7 15.5c0 1.96 1.54 3.5 3.5 3.5zM20 16h7v2h-7v-2zM20 20h7v2h-7v-2z"
      {...props}
    />
  )
}

const ImproveCredit = (props: GroupProps) => (
  <React.Fragment>
    <g {...props}>
      <path d="M6.044 22.971a.687.687 0 01-.646-.454 13.353 13.353 0 01-.8-4.517 13.411 13.411 0 0113.4-13.4 13.3 13.3 0 019.525 3.977.685.685 0 01-.005.969.685.685 0 01-.969-.005 11.94 11.94 0 00-8.551-3.569A12.039 12.039 0 005.972 17.997a11.991 11.991 0 00.716 4.055.687.687 0 01-.414.877.689.689 0 01-.23.042z" />
      <path d="M19.678 16.771a.686.686 0 01-.485-.2.685.685 0 010-.969l4.781-4.78a.686.686 0 01.969 0 .686.686 0 010 .969l-4.781 4.779a.683.683 0 01-.484.201zM14.859 21.589a.685.685 0 01-.485-.2.686.686 0 010-.969l1.361-1.36a.685.685 0 01.969 0 .685.685 0 010 .969l-1.36 1.36a.684.684 0 01-.485.2z" />
      <path d="M34.316 24.475a.69.69 0 01-.23-.039.685.685 0 01-.416-.876 16.565 16.565 0 00.962-5.561A16.648 16.648 0 0018.003 1.37a16.648 16.648 0 00-16.63 16.629 16.556 16.556 0 00.962 5.561.686.686 0 01-.416.876.685.685 0 01-.876-.416 17.927 17.927 0 01-1.042-6.021 18.02 18.02 0 0118-18 18.02 18.02 0 0118 18 17.919 17.919 0 01-1.042 6.021.685.685 0 01-.643.455z" />
      <path d="M17.946 20.956a3.139 3.139 0 01-3.135-3.135 3.14 3.14 0 013.135-3.136 3.14 3.14 0 013.135 3.136 3.139 3.139 0 01-3.135 3.135zm0-4.9a1.767 1.767 0 00-1.764 1.765 1.767 1.767 0 001.764 1.764 1.767 1.767 0 001.765-1.764 1.767 1.767 0 00-1.765-1.765z" />
      <path
        sx={{ fill: '#059b9a' }}
        d="M29.883 22.31a.688.688 0 01-.281-.06l-2.073-.93-2.073.93a.687.687 0 01-.683-.071.686.686 0 01-.279-.628l.244-2.258-1.525-1.684a.685.685 0 01-.143-.672.685.685 0 01.51-.459l2.223-.466 1.131-1.97a.712.712 0 011.188 0l1.131 1.97 2.224.466a.685.685 0 01.51.459.684.684 0 01-.143.672l-1.525 1.684.243 2.258a.685.685 0 01-.279.628.684.684 0 01-.4.131zm-2.354-2.426a.686.686 0 01.28.06l1.264.566-.148-1.377a.687.687 0 01.174-.533l.929-1.026-1.355-.284a.686.686 0 01-.454-.329l-.689-1.2-.689 1.2a.685.685 0 01-.453.329l-1.355.284.929 1.026a.687.687 0 01.174.533l-.149 1.377 1.263-.566a.686.686 0 01.279-.061z"
      />
    </g>
  </React.Fragment>
)

const InfoCircle = (props: GroupProps) => (
  <React.Fragment>
    <g
      data-name="Icon feather-info"
      fill="none"
      stroke="#d91828"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    >
      <path
        data-name="Path 5610"
        d="M20.75 10.75a10 10 0 1 1-10-10 10 10 0 0 1 10 10Z"
      />
      <path data-name="Path 5611" d="M10.75 14.9v-4.4" />
      <path data-name="Path 5612" d="M10.75 6.75h0" />
    </g>
  </React.Fragment>
)

const Key = (props: PathProps) => (
  <path
    d="M 20 3 C 15.054545 3 11 7.0545455 11 12 C 11 12.519086 11.08466 12.978272 11.15625 13.4375 L 3.28125 21.28125 L 3 21.59375 L 3 22 L 3 28 L 3 29 L 4 29 L 9 29 L 10 29 L 10 28 L 10 26 L 12 26 L 13 26 L 13 25 L 13 23 L 15 23 L 16 23 L 16 22 L 16 20.03125 C 17.181148 20.608598 18.555233 21 20 21 C 24.945455 21 29 16.945455 29 12 C 29 7.0545455 24.945455 3 20 3 z M 20 5 C 23.854545 5 27 8.1454545 27 12 C 27 15.854545 23.854545 19 20 19 C 18.790476 19 17.544638 18.643666 16.59375 18.125 L 16.34375 18 L 16.09375 18 L 15 18 L 14 18 L 14 19 L 14 21 L 12 21 L 11 21 L 11 22 L 11 24 L 9 24 L 8 24 L 8 25 L 8 27 L 5 27 L 5 22.4375 L 12.90625 14.5 L 13.28125 14.15625 L 13.1875 13.625 C 13.0875 13.025 13 12.488889 13 12 C 13 8.1454545 16.145455 5 20 5 z M 22 8 C 20.895431 8 20 8.8954305 20 10 C 20 11.104569 20.895431 12 22 12 C 23.104569 12 24 11.104569 24 10 C 24 8.8954305 23.104569 8 22 8 z"
    {...props}
  />
)

const Keyboard = (props: PathProps) => (
  <path
    d="M3 7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h26c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H3zm0 2h26v14H3V9zm2 2v2h2v-2H5zm4 0v2h2v-2H9zm4 0v2h2v-2h-2zm4 0v2h2v-2h-2zm4 0v2h2v-2h-2zm4 0v2h2v-2h-2zM5 15v2h4v-2H5zm6 0v2h2v-2h-2zm4 0v2h2v-2h-2zm4 0v2h2v-2h-2zm4 0v2h4v-2h-4zM5 19v2h4v-2H5zm6 0v2h10v-2H11zm12 0v2h4v-2h-4z"
    {...props}
  />
)

const Lightbulb = (props: PathProps) => (
  <path
    d="M6.81 2.4l-1.4 1.41 2.09 2.1L8.9 4.5 6.82 2.4zm18.38 0l-2.1 2.1 1.41 1.4 2.1-2.09-1.41-1.4zM16 3.04c-.33 0-.66.02-1 .06h-.03a9.08 9.08 0 0 0-7.85 7.79c-.44 3.24.9 6.2 3.13 8.09A5.24 5.24 0 0 1 12 22v6H14.28a1.98 1.98 0 0 0 3.44 0H20v-4h.1v-1.19c0-1.46.76-2.94 2-4.1A9.58 9.58 0 0 0 25 12a8.99 8.99 0 0 0-9-8.97zm0 2c3.86-.05 7 3.1 7 6.97 0 2.1-.97 3.94-2.31 5.28l.03.03A7.79 7.79 0 0 0 18.28 22h-4.37a7.1 7.1 0 0 0-2.35-4.56 6.94 6.94 0 0 1-2.47-6.32A7.07 7.07 0 0 1 16 5.04zM2 12v2h3v-2H2zm25 0v2h3v-2h-3zM7.5 20.1l-2.1 2.09 1.41 1.4 2.1-2.09-1.41-1.4zm17 0l-1.4 1.4 2.09 2.1 1.4-1.41-2.09-2.1zM14 24h4v2h-4v-2z"
    {...props}
  />
)

const Link = (props: PathProps) => (
  <path
    d="M21.75 4c-1.67 0-3.26.66-4.44 1.84l-1.47 1.47a6.26 6.26 0 0 0-1.4 6.72l1.62-1.62c-.2-1.3.2-2.7 1.19-3.7l1.47-1.46a4.27 4.27 0 0 1 6.03 6.03l-1.47 1.47a4.28 4.28 0 0 1-3.69 1.19l-1.62 1.62a6.25 6.25 0 0 0 6.72-1.4l1.47-1.47A6.26 6.26 0 0 0 21.75 4zm-2.47 7.28l-8 8 1.44 1.44 8-8-1.44-1.44zM11.75 14c-1.67 0-3.26.66-4.44 1.84l-1.47 1.47a6.26 6.26 0 1 0 8.85 8.85l1.47-1.47a6.26 6.26 0 0 0 1.4-6.72l-1.62 1.62c.2 1.3-.2 2.7-1.19 3.7l-1.47 1.46a4.27 4.27 0 0 1-6.03-6.03l1.47-1.47a4.28 4.28 0 0 1 3.69-1.19l1.62-1.62a6.16 6.16 0 0 0-2.28-.44z"
    {...props}
  />
)

const LocationArrow = (props: PathProps) => (
  <path
    d="M444.52 3.52L28.74 195.42c-47.97 22.39-31.98 92.75 19.19 92.75h175.91v175.91c0 51.17 70.36 67.17 92.75 19.19l191.9-415.78c15.99-38.39-25.59-79.97-63.97-63.97z"
    {...props}
  />
)

const Lock = (props: PathProps) => (
  <path
    d="M16 3c-3.85 0-7 3.15-7 7v3H6v16h20V13h-3v-3c0-3.85-3.15-7-7-7zm0 2a5 5 0 0 1 5 5v3H11v-3a5 5 0 0 1 5-5zM8 15h16v12H8V15z"
    {...props}
  />
)

const MapMarker = (props: PathProps) => (
  <path
    d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"
    {...props}
  />
)

const Meh = (props: PathProps) => (
  <path
    d="M16 4C9.38 4 4 9.38 4 16s5.38 12 12 12 12-5.38 12-12S22.62 4 16 4zm0 2c5.53 0 10 4.47 10 10s-4.47 10-10 10S6 21.53 6 16 10.47 6 16 6zm-4.5 6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm9 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM11 20v2h10v-2H11z"
    {...props}
  />
)

const Menu = (props: PathProps) => (
  <path
    d="M26.82 18H5.18C4 18 4 17.18 4 16c0-1.18 0-2 1.18-2H26.8c1.18 0 1.18.82 1.18 2 0 1.18 0 2-1.18 2h.02zm0-8H5.18C4 10 4 9.18 4 8c0-1.18 0-2 1.18-2H26.8c1.18 0 1.18.82 1.18 2 0 1.18 0 2-1.18 2h.02zM5.18 22H26.8c1.18 0 1.18.82 1.18 2 0 1.18 0 2-1.18 2H5.18C4 26 4 25.18 4 24c0-1.18 0-2 1.18-2z"
    {...props}
  />
)

const MoneyMan = (props: GroupProps) => (
  <React.Fragment>
    <g {...props}>
      <path
        d="M80.314 131.277a4.325 4.325 0 01-.5-.027l-23.033-2.526.988-9 18.533 2.034 9.064-82.623-43.168-4.737-5.062 46.174-9-.985 5.557-50.674a4.518 4.518 0 011.666-3.036 4.532 4.532 0 013.326-.969l52.164 5.723a4.523 4.523 0 014 4.991L84.8 127.243a4.522 4.522 0 01-4.486 4.034z"
        sx={{ fill: '#9fd96b' }}
      />
    </g>
    <g>
      <path
        d="M89.9 140.964a4.492 4.492 0 01-1.092-.134l-34.877-8.685 2.186-8.783 30.48 7.591 19.8-79.955-17.908-4.438 2.176-8.785 22.3 5.526a4.515 4.515 0 012.785 2.055 4.516 4.516 0 01.516 3.424l-21.98 88.748a4.534 4.534 0 01-2.057 2.789 4.525 4.525 0 01-2.329.647z"
        sx={{ fill: '#9fd96b' }}
      />
    </g>
    <g>
      <path
        d="M59.453 96.632a22.144 22.144 0 01-2.408-.13 22.992 22.992 0 01-3.2-.572l2.225-8.772a13.961 13.961 0 001.941.347c6.01.641 11.3-2.7 11.813-7.452s-3.967-9.145-9.98-9.792a12.318 12.318 0 00-8.268 1.916 7.741 7.741 0 00-3.549 5.534 6.943 6.943 0 00.432 3.258l-8.455 3.221a15.839 15.839 0 01-.977-7.436 16.646 16.646 0 017.445-12.052 21.385 21.385 0 0114.338-3.439c10.975 1.18 19.053 10.042 18.014 19.753-.966 8.992-9.417 15.616-19.371 15.616z"
        sx={{ fill: '#9fd96b' }}
      />
    </g>
    <g>
      <path
        d="M204.205 174.266a56.632 56.632 0 01-56.568-56.564 56.633 56.633 0 0156.568-56.567 56.632 56.632 0 0156.568 56.567 56.631 56.631 0 01-56.568 56.564zm0-104.083a47.572 47.572 0 00-47.518 47.518 47.571 47.571 0 0047.518 47.516 47.571 47.571 0 0047.518-47.516 47.572 47.572 0 00-47.518-47.518z"
        sx={{ fill: '#fff' }}
      />
    </g>
    <g>
      <path
        d="M28.363 144.455a48.445 48.445 0 01-4.842-.243l-.166-.015c-6.244-.59-10.541-1.485-13.133-2.738a16.86 16.86 0 01-8.514-8.263c-3.73-8.244-.588-19.579 2.186-29.581l.365-1.308c4.133-14.8 8.049-28.783 28.074-26.8l1.65.155c4.3.4 7.414.691 12.537 2.976 14.119 6.323 21.959 24.647 17.48 40.851-4.23 15.34-18.244 24.966-35.637 24.966zm.072-60.1c-9.285 0-11.318 5.563-15.457 20.389l-.365 1.3c-2.244 8.088-5.039 18.166-2.662 23.412.455 1 1.389 2.5 4.207 3.854.719.348 3.137 1.223 10.049 1.877l.193.019c12.557 1.256 26.949-3.87 30.881-18.123 3.615-13.1-3.518-26.176-12.453-30.176-3.754-1.675-5.734-1.859-9.684-2.226l-1.705-.162a30.046 30.046 0 00-3.005-.168z"
        sx={{ fill: '#fff' }}
      />
    </g>
    <g>
      <path
        d="M124.875 30.562a4.514 4.514 0 01-3.2-1.322 4.526 4.526 0 010-6.4l7.439-7.451a4.529 4.529 0 016.4 0 4.529 4.529 0 01.006 6.4l-7.443 7.451a4.51 4.51 0 01-3.202 1.322z"
        sx={{ fill: '#fff' }}
      />
    </g>
    <g>
      <path
        d="M93.739 19.584a4.524 4.524 0 01-4.525-4.523V4.525A4.525 4.525 0 0193.739.001a4.523 4.523 0 014.523 4.524v10.536a4.522 4.522 0 01-4.523 4.523z"
        sx={{ fill: '#fff' }}
      />
    </g>
    <g>
      <path
        d="M140.878 63.574h-10.537a4.527 4.527 0 01-4.525-4.525 4.527 4.527 0 014.525-4.525h10.537a4.526 4.526 0 014.525 4.525 4.526 4.526 0 01-4.525 4.525z"
        sx={{ fill: '#fff' }}
      />
    </g>
    <g>
      <path
        d="M272.635 309.103a4.413 4.413 0 01-.867-.083 4.521 4.521 0 01-3.578-5.3l8.428-43.428c1.846-16.785-1.668-30.57-10.447-40.977-12.248-14.514-34.422-22.79-65.906-24.6-39.41-2.255-88.682-10.8-120.178-57.263a4.525 4.525 0 011.2-6.285 4.526 4.526 0 016.285 1.205c23.15 34.147 57.006 50.089 113.207 53.307 34.064 1.956 58.387 11.307 72.3 27.8 10.479 12.418 14.686 28.568 12.506 48-.014.12-.029.239-.053.357l-8.465 43.61a4.527 4.527 0 01-4.432 3.657z"
        sx={{ fill: '#fff' }}
      />
    </g>
    <g>
      <path
        d="M121.355 309.103a4.524 4.524 0 01-.8-.071 4.528 4.528 0 01-3.662-5.25l11.2-62.735a169.971 169.971 0 01-56.18-34.122c-20.164-18.459-34.8-41.17-42.316-65.676a4.527 4.527 0 013-5.654 4.529 4.529 0 015.654 3c15.982 52.1 61.914 83.81 96.389 95.136a4.532 4.532 0 013.047 5.094l-11.883 66.548a4.527 4.527 0 01-4.449 3.73z"
        sx={{ fill: '#fff' }}
      />
    </g>
    <g>
      <path
        d="M220.397 309.102a4.372 4.372 0 01-.7-.056 4.52 4.52 0 01-3.77-5.17l5.734-36.666a4.529 4.529 0 015.172-3.772 4.523 4.523 0 013.77 5.17l-5.738 36.667a4.525 4.525 0 01-4.468 3.827z"
        sx={{ fill: '#fff' }}
      />
    </g>
  </React.Fragment>
)
const MoneyPlus = (props: GroupProps) => (
  <React.Fragment>
    <defs />
    <g
      {...props}
      sx={{
        strokeLinejoin: 'round',
        strokeWidth: '2',
        fill: 'transparent',
      }}
    >
      <path d="M35.516 34.381c-2.28-4.408-7.5-7.6-15.21-8.608-4.879-.635-6.619-1.988-7.523-2.791-1.957-1.74-.934-8.21 5.986-8.21 3.816 0 6.915 2.619 6.919 5.836h10.778c-.008-6.725-5.269-12.406-12.52-14.271V.998H13.575l-.008 5.341c-16.051 4-19.11 26.295 5.024 29.086 3.363.388 5.275 1.446 6.065 2.165 2.254 2.053 1.036 8.093-5.892 8.093a7.067 7.067 0 01-6.342-3.513H1.296c1.047 5.679 5.884 10.292 12.268 11.944l.01 4.832h10.371v-4.827a15.361 15.361 0 003.854-1.306" />
      <path
        sx={{
          stroke: '#6c3',
          strokeLinecap: 'round',
          fill: 'transparent',
        }}
        d="M51.682 43.916v14.981H30.896V38.113h15.847"
      />
      <path
        sx={{
          stroke: '#6c3',
          fill: 'transparent',
          strokeLinecap: 'round',
        }}
        d="M35.969 47.282l5.326 4.987 11.69-15.457"
      />
    </g>
  </React.Fragment>
)
const MoneyRocket = () => (
  <React.Fragment>
    <defs />
    <path d="M10.177 30.78a27.8 27.8 0 00-7.211 2.7.3.3 0 01-.275-.1.289.289 0 01-.1-.273 27.7 27.7 0 002.668-7.211c.428-2.009 1.158-3.353 2.167-3.993l-.658-1.032c-1.3.823-2.211 2.428-2.709 4.771a26.5 26.5 0 01-2.551 6.891 1.474 1.474 0 00.322 1.715 1.576 1.576 0 001.1.469 1.331 1.331 0 00.626-.154 26.525 26.525 0 016.883-2.593c2.336-.509 3.938-1.433 4.762-2.745l-1.041-.649c-.642 1.028-1.982 1.768-3.983 2.204z" />
    <path
      d="M35.574.437c-.872-.873-7.509-.321-9.921.624a24.125 24.125 0 00-8.436 5.626 31.806 31.806 0 00-2.615 2.948A14.006 14.006 0 002.195 13.22a11.1 11.1 0 00-2.1 3.142 1.183 1.183 0 001.424 1.576 17.326 17.326 0 018.739-.049l-2.59 1.234a.61.61 0 00-.25.885 34.087 34.087 0 003.869 4.7 31.369 31.369 0 004.758 3.847.615.615 0 00.867-.269l1.233-2.637a17.1 17.1 0 01-.012 8.848 1.147 1.147 0 00.35 1.2 1.185 1.185 0 00.791.309 1.124 1.124 0 00.442-.091 11.171 11.171 0 003.156-2.1 13.848 13.848 0 003.54-12.614 30.022 30.022 0 002.874-2.5 24 24 0 005.638-8.411c.944-2.401 1.514-8.995.65-9.853zm-34.308 16.3a10.074 10.074 0 011.836-2.692 12.715 12.715 0 0110.7-3.338 20.932 20.932 0 00-3.063 6.051 18.473 18.473 0 00-9.473-.023zM22.04 32.91a10.132 10.132 0 01-2.7 1.83 18.232 18.232 0 00-.069-9.609 22.524 22.524 0 006.065-3.138 12.572 12.572 0 01-3.295 10.915zm6.372-15.07c-2.739 2.729-7.107 5.772-10.69 6.419a.614.614 0 00-.447.343l-1.183 2.53a33.917 33.917 0 01-3.942-3.29 34.69 34.69 0 01-3.312-3.922l2.446-1.165a.614.614 0 00.339-.442c.618-3.363 2.974-7.285 6.461-10.76a23.039 23.039 0 017.651-5.2l7.886 7.856a22.9 22.9 0 01-5.209 7.629z"
      fill="#0c0636"
    />
    <path d="M27.175 8.206l-.591.588a2.414 2.414 0 00-3.1.206c-1.037 1.033-.33 2.145.239 3.038.637 1 .966 1.6.313 2.249a1.544 1.544 0 01-2.109-.263 1.857 1.857 0 010-2.63l-.59-.588a2.685 2.685 0 00-.27 3.486l-.562.559.59.588.56-.557a2.282 2.282 0 002.971-.008c1.156-1.152.374-2.383-.2-3.281-.639-1-.865-1.5-.353-2.005a1.614 1.614 0 012.243.062 1.856 1.856 0 010 2.63l.59.588a2.685 2.685 0 00.27-3.486l.59-.587z" />
  </React.Fragment>
)
const Online = () => (
  <React.Fragment>
    <defs />
    <path
      d="M1.437 2.879a.3.3 0 01.175-.04h13.771V1.47H1.611a1.554 1.554 0 00-1.16.458A1.757 1.757 0 000 3.116v15.649a1.807 1.807 0 001.8 1.806h5.96v.745H5.811a.685.685 0 00-.684.684.685.685 0 00.684.684h4.887a.685.685 0 00.685-.684.685.685 0 00-.685-.684H9.135v-1.429a.685.685 0 00-.685-.684H1.806a.437.437 0 01-.436-.437v-1.01h11.387v-1.369H1.37V3.101a.4.4 0 01.067-.222z"
      sx={{ fill: '#0c0636' }}
    />
    <path
      d="M35.82 3.26a7.314 7.314 0 00-1.676-1.915 8.152 8.152 0 00-2.36-1.284 1.368 1.368 0 00-1.312.287l-1.782 1.6a1.357 1.357 0 00-.4 1.352l.608 2.276c-.779 2.018-2.4 6.1-7.81 6.385-4.348.23-9.34 1.208-9.34 6.779v.187h1.369v-.187c0-3.5 2.405-5.114 8.043-5.412 6.35-.335 8.2-5.153 9.1-7.468a.684.684 0 00.022-.422l-.667-2.474 1.766-1.6a6.9 6.9 0 011.921 1.051A6.393 6.393 0 0134.64 3.92l-2.044 3.122a.733.733 0 00-.086.189 17.853 17.853 0 01-6.324 9.379.68.68 0 00-.268.541v1.573h1.369v-1.241A19.229 19.229 0 0033.8 7.702l1.988-3.035a1.345 1.345 0 00.032-1.407z"
      sx={{ fill: '#059b9a' }}
    />
    <path
      d="M20.968 11.29a5.6 5.6 0 005.591-5.589A5.6 5.6 0 0020.968.11a5.6 5.6 0 00-5.593 5.591 5.6 5.6 0 005.593 5.589zm0-9.812A4.227 4.227 0 0125.19 5.7a4.227 4.227 0 01-4.222 4.221A4.227 4.227 0 0116.744 5.7a4.228 4.228 0 014.224-4.224z"
      sx={{ fill: '#059b9a' }}
    />
    <path
      d="M26.953 18.001h-14.3a2.42 2.42 0 00-2.418 2.416v4.377h1.369v-4.377a1.049 1.049 0 011.05-1.047h14.3a1.05 1.05 0 011.05 1.047v4.377h1.369v-4.377a2.419 2.419 0 00-2.42-2.416z"
      sx={{ fill: '#0c0636' }}
    />
  </React.Fragment>
)
const PayoffDebt = (props: GroupProps) => (
  <React.Fragment>
    <g {...props}>
      <path d="M21.955 29a1.357 1.357 0 01-.78-.255c-.038-.025-3.816-2.614-5.1-3.539a1.564 1.564 0 01-.511-1.517 1.514 1.514 0 01.92-1.127 1.445 1.445 0 01.76-.837 1.436 1.436 0 011.328.124l2.269 1.54a2.5 2.5 0 01-.255-.539 2.033 2.033 0 011.085-2.659l8.125-3.685a.569.569 0 01.064-.025 3.659 3.659 0 012.225.064l3.915.744-.208 1.12-3.946-.749a.579.579 0 01-.06-.015 2.615 2.615 0 00-1.563-.084l-8.13 3.686a.927.927 0 00-.441 1.237 1.024 1.024 0 001.053.779l3.73-1.566a.56.56 0 01.736.308.572.572 0 01-.3.745l-5.276 2.215a.558.558 0 01-.53-.053l-3.1-2.1a.322.322 0 00-.271-.037.473.473 0 00-.2.352.566.566 0 01-.421.439c-.325.078-.374.246-.391.3a.534.534 0 00.06.425c1.264.907 5.032 3.488 5.07 3.514a.223.223 0 00.234.044l5.319-1.63a7.8 7.8 0 001.094-.5c.078-.049.215-.14.383-.252a20.248 20.248 0 013.908-2.161c.018-.006.037-.012.055-.016l2.81-.689.266 1.108-2.783.682a19.521 19.521 0 00-3.637 2.028c-.179.119-.325.216-.427.28a8.848 8.848 0 01-1.32.605l-5.344 1.639a1.427 1.427 0 01-.415.057zM9.224 19.572a2.667 2.667 0 01-1.869-.92 2.058 2.058 0 01-.514-1.641l1.118.147a.927.927 0 00.245.745 1.682 1.682 0 00.759.485l.861-1.252a.562.562 0 01.449-.244.549.549 0 01.46.221 1.554 1.554 0 00.619.44l.984-1.9 1 .528-1.2 2.325a.56.56 0 01-.6.3 3.28 3.28 0 01-1.146-.481l-.7 1.011a.562.562 0 01-.466.236zM3.501 10.04h-.017l-1.932-.057.033-1.14 1.764.053 6.365-3.931a.555.555 0 01.269-.083l7.021-.317.051 1.138-6.876.311-6.384 3.943a.566.566 0 01-.294.083z" />
      <path
        d="M12.95 11.56l-.906-.679L19.858.227a.561.561 0 01.37-.224.554.554 0 01.418.106l7.193 5.393a.574.574 0 01.117.8l-1.154 1.574-.905-.679.818-1.116-6.288-4.714z"
        sx={{ fill: '#059b9a' }}
      />
      <path
        d="M17.666 20.96a.56.56 0 01-.381-.15l-5.747-5.325.762-.84 5.329 4.938 9.373-10.432-5.794-5.321-6.514 7.249-.834-.766 6.893-7.671a.56.56 0 01.8-.039l6.628 6.087a.577.577 0 01.184.395.572.572 0 01-.146.41L18.086 20.772a.562.562 0 01-.391.186z"
        sx={{ fill: '#059b9a' }}
      />
      <path
        d="M19.417 14.794a3.024 3.024 0 01-2.052-.8 3.072 3.072 0 01-.638-.827l.994-.537a1.955 1.955 0 00.4.521 1.914 1.914 0 002.721-.133 1.951 1.951 0 00.5-1.4 1.946 1.946 0 00-.63-1.349 1.909 1.909 0 00-1.388-.5 1.905 1.905 0 00-1.333.636 1.943 1.943 0 00-.4.7l-1.07-.358a3.07 3.07 0 01.64-1.108 3.018 3.018 0 012.114-1.008 3.021 3.021 0 012.2.8 3.084 3.084 0 011 2.138 3.09 3.09 0 01-.791 2.225 3.033 3.033 0 01-2.267 1zM21.166 6.03a2.929 2.929 0 01-1.994-.781l.759-.844a1.816 1.816 0 001.328.482 1.826 1.826 0 001.277-.609l.834.766a2.942 2.942 0 01-2.058.981c-.048.004-.097.005-.146.005zM25.85 11.384a3.033 3.033 0 01-.2-4.245l.834.766a1.882 1.882 0 00.125 2.635zM16.308 19.128l-.834-.767a2.954 2.954 0 014.2-.2l-.757.844a1.834 1.834 0 00-2.609.123z"
        sx={{ fill: '#059b9a' }}
      />
      <path d="M5.624 18.203a4.619 4.619 0 01-1.5-.275l-4.126-1.672.42-1.058 4.1 1.662a2.617 2.617 0 002.191-.065l4.288-2.014c.019-.009.039-.016.058-.023l5.259-1.781a.976.976 0 00.459-1.33c-.159-.466-.477-.983-1.082-.812l-5.222 1.706a.559.559 0 01-.59-.158.576.576 0 01-.1-.608l1.424-3.361a.565.565 0 01.452-.342s2.6-.311 3.008-.358l.126 1.133c-.318.036-1.969.233-2.677.318l-.807 1.906 4.065-1.327a2 2 0 012.472 1.531 2.1 2.1 0 01-1.15 2.777l-5.247 1.777-4.257 2a3.509 3.509 0 01-1.564.374z" />
    </g>
  </React.Fragment>
)

const Passport = (props: PathProps) => (
  <path
    fillRule="evenodd"
    d="M6 2h20a2 2 0 0 1 2 2v24a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2zM2 4a4 4 0 0 1 4-4h20a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V4zm6 9a8 8 0 1 0 16 0 8 8 0 0 0-16 0zm2.1-1h2.44c.1-1.69.41-3.2.9-4.4-1.74.83-3 2.45-3.34 4.4zm0 2a6 6 0 0 0 3.33 4.4c-.48-1.2-.8-2.71-.89-4.4H10.1zm5.9 4.92c.48-.47 1.3-2.15 1.46-4.92h-2.93c.17 2.77.99 4.45 1.47 4.92zM14.54 12h2.93c-.17-2.77-.99-4.45-1.47-4.92-.48.47-1.3 2.15-1.46 4.92zm4.03 6.4c1.73-.83 3-2.45 3.33-4.4h-2.44c-.1 1.69-.41 3.2-.9 4.4zm0-10.8c.48 1.2.8 2.71.89 4.4h2.44a5.99 5.99 0 0 0-3.33-4.4zM8 26a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1 1 1 0 0 0-1-1H9a1 1 0 0 0-1 1z"
    {...props}
  />
)

const Phone = (props: PathProps) => (
  <path
    d="M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"
    {...props}
  />
)

const PhoneAlt = (props: GroupProps) => (
  <React.Fragment>
    <g transform="translate(-236 -35)" {...props}>
      <path
        d="M340.61,46.86c51.2,0.05,92.69,41.54,92.76,92.74c-0.05,51.2-41.56,92.7-92.76,92.76
          c-51.21-0.05-92.7-41.54-92.76-92.76C247.9,88.41,289.41,46.92,340.61,46.86 M340.61,35C282.83,35,236,81.83,236,139.61
          s46.83,104.61,104.61,104.61s104.61-46.83,104.61-104.61S398.38,35,340.61,35z"
      />
      <path
        d="M398.8,165.92L398.8,165.92c-4.9-4.92-9.9-9.9-14.77-14.74l-0.5-0.5
          c-2.66-2.81-6.34-4.43-10.21-4.51c-3.89,0.07-7.57,1.72-10.24,4.55c-2.66,2.64-5.42,5.37-8.15,8.15l-0.79-0.39
          c-1.18-0.59-2.32-1.13-3.28-1.74c-8.59-5.56-16.21-12.5-22.54-20.54c-2.79-3.31-5.17-6.95-7.07-10.84
          c2.29-2.24,4.55-4.53,6.74-6.74l1.4-1.4c5.73-5.03,6.3-13.75,1.27-19.49c-0.4-0.45-0.82-0.87-1.27-1.27l-3.69-3.71l-3.75-3.77
          l-2.5-2.51l-0.17-0.17c-1.64-1.66-3.35-3.36-5.06-5.05c-2.67-2.77-6.33-4.37-10.18-4.44c-3.86,0.07-7.53,1.68-10.2,4.48
          c-1.26,1.24-2.5,2.5-3.71,3.71l-0.14,0.14c-1.73,1.74-3.69,3.74-5.58,5.58c-3.78,3.55-6.05,8.41-6.36,13.59
          c-0.33,7.21,0.93,14.4,3.69,21.06c4.99,13.01,12.21,25.06,21.34,35.58c11.96,14.32,26.82,25.95,43.6,34.12
          c7.79,4.09,16.33,6.56,25.11,7.25c0.6,0,1.18,0,1.76,0c6.38,0.22,12.53-2.43,16.74-7.24c1.68-1.87,3.59-3.73,5.42-5.58
          c0.95-0.92,2.02-1.97,3.07-3.01c5.69-5.06,6.19-13.77,1.13-19.46C399.55,166.65,399.18,166.28,398.8,165.92z M382.98,188.63
          c-2.7,3.02-6.72,4.49-10.73,3.95c-7.48-0.61-14.77-2.75-21.39-6.29c-15.56-7.57-29.35-18.34-40.45-31.62
          c-8.41-9.67-15.06-20.74-19.66-32.71c-2.28-5.33-3.34-11.11-3.11-16.9c0.14-2.76,1.33-5.37,3.35-7.27
          c2.01-1.91,3.95-3.88,5.82-5.76c1.23-1.24,2.48-2.51,3.77-3.77c0.86-0.98,2.06-1.58,3.36-1.68c1.3,0.1,2.51,0.69,3.37,1.66
          c1.66,1.62,3.33,3.31,4.98,4.96l0.1,0.1l2.55,2.57l3.53,3.54l0.39,0.39l3.53,3.54c1.93,1.36,2.38,4.02,1.02,5.95
          c-0.28,0.4-0.63,0.75-1.02,1.02l-1.28,1.3c-2.61,2.64-5.32,5.36-8.02,7.99l0,0c-2.16,2.01-2.77,5.17-1.52,7.84
          c2.34,5.36,5.44,10.35,9.22,14.81c7.01,8.87,15.43,16.52,24.93,22.65c1.4,0.88,2.79,1.56,4.18,2.22l0,0
          c0.78,0.39,1.52,0.75,2.2,1.12c1.05,0.62,2.24,0.95,3.46,0.96c1.92-0.03,3.74-0.85,5.02-2.29c3.05-3.14,6.25-6.3,9.34-9.37l0,0
          c0.85-0.98,2.04-1.58,3.33-1.69c1.29,0.11,2.5,0.71,3.35,1.69l0.27,0.25c4.92,4.9,10,9.94,14.97,14.94
          c1.93,1.36,2.38,4.02,1.02,5.95c-0.28,0.4-0.63,0.75-1.02,1.02c-0.98,0.98-2.02,2-2.94,2.9
          C386.91,184.54,384.89,186.51,382.98,188.63z"
      />
    </g>
  </React.Fragment>
)

const Print = (props: PathProps) => (
  <path
    d="M9 4v7H7c-1.64 0-3 1.36-3 3v10h5v4h14v-4h5V14c0-1.64-1.36-3-3-3h-2V4H9zm2 2h10v5H11V6zm-4 7h18c.57 0 1 .43 1 1v8h-3v-4H9v4H6v-8c0-.57.43-1 1-1zm1 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm3 6h10v6H11v-6z"
    {...props}
  />
)

const Question = (props: PathProps) => (
  <path
    d="M16 4C9.38 4 4 9.38 4 16s5.38 12 12 12 12-5.38 12-12S22.62 4 16 4zm0 2c5.53 0 10 4.47 10 10s-4.47 10-10 10S6 21.53 6 16 10.47 6 16 6zm0 4c-2.2 0-4 1.8-4 4h2c0-1.12.88-2 2-2s2 .88 2 2c0 .77-.5 1.45-1.22 1.69l-.4.12a2.02 2.02 0 0 0-1.38 1.9V19h2v-1.28l.4-.13A3.8 3.8 0 0 0 20 14c0-2.2-1.8-4-4-4zm-1 10v2h2v-2h-2z"
    {...props}
  />
)

const QuoteClose = (props: GroupProps) => (
  <g transform="translate(-470 -630)" {...props}>
    <g transform="translate(559 670)">
      <g transform="translate(-35 5) rotate(180)">
        <path
          d="M432.56,1316.795c0-11.5,7.272-21.962,15.065-28.236l5.715,3.659c-5.455,4.706-8.182,9.021-8.961,14.641a10.817,10.817,0,0,1,9.871,10.851,10.6,10.6,0,0,1-10.65,10.849C437.234,1328.558,432.56,1323.853,432.56,1316.795Zm28.312,0c0-11.5,7.272-21.962,15.065-28.236l5.715,3.659c-5.455,4.706-8.182,9.021-8.961,14.641a10.817,10.817,0,0,1,9.871,10.851,10.6,10.6,0,0,1-10.65,10.849C465.547,1328.558,460.872,1323.853,460.872,1316.795Z"
          transform="translate(-432.56 -1288.558)"
        />
        <path
          d="M432.56,1316.795c0-11.5,7.272-21.962,15.065-28.236l5.715,3.659c-5.455,4.706-8.182,9.021-8.961,14.641a10.817,10.817,0,0,1,9.871,10.851,10.6,10.6,0,0,1-10.65,10.849C437.234,1328.558,432.56,1323.853,432.56,1316.795Zm28.312,0c0-11.5,7.272-21.962,15.065-28.236l5.715,3.659c-5.455,4.706-8.182,9.021-8.961,14.641a10.817,10.817,0,0,1,9.871,10.851,10.6,10.6,0,0,1-10.65,10.849C465.547,1328.558,460.872,1323.853,460.872,1316.795Z"
          transform="translate(-432.56 -1288.558)"
        />
      </g>
    </g>
  </g>
)

const QuoteOpen = (props: GroupProps) => (
  <g transform="translate(-196 -691)" {...props}>
    <g transform="translate(242 701)">
      <g transform="translate(-35 5)">
        <path
          d="M432.56,1316.795c0-11.5,7.272-21.962,15.065-28.236l5.715,3.659c-5.455,4.706-8.182,9.021-8.961,14.641a10.817,10.817,0,0,1,9.871,10.851,10.6,10.6,0,0,1-10.65,10.849C437.234,1328.558,432.56,1323.853,432.56,1316.795Zm28.312,0c0-11.5,7.272-21.962,15.065-28.236l5.715,3.659c-5.455,4.706-8.182,9.021-8.961,14.641a10.817,10.817,0,0,1,9.871,10.851,10.6,10.6,0,0,1-10.65,10.849C465.547,1328.558,460.872,1323.853,460.872,1316.795Z"
          transform="translate(-432.56 -1288.558)"
        />
        <path
          d="M432.56,1316.795c0-11.5,7.272-21.962,15.065-28.236l5.715,3.659c-5.455,4.706-8.182,9.021-8.961,14.641a10.817,10.817,0,0,1,9.871,10.851,10.6,10.6,0,0,1-10.65,10.849C437.234,1328.558,432.56,1323.853,432.56,1316.795Zm28.312,0c0-11.5,7.272-21.962,15.065-28.236l5.715,3.659c-5.455,4.706-8.182,9.021-8.961,14.641a10.817,10.817,0,0,1,9.871,10.851,10.6,10.6,0,0,1-10.65,10.849C465.547,1328.558,460.872,1323.853,460.872,1316.795Z"
          transform="translate(-432.56 -1288.558)"
        />
      </g>
    </g>
  </g>
)

const RepayOverTime = (props: GroupProps) => (
  <React.Fragment>
    <g {...props}>
      <path d="M18 7.791a2.627 2.627 0 01-2.631-2.618A2.625 2.625 0 0118 2.56a2.625 2.625 0 012.631 2.613A2.628 2.628 0 0118 7.791zm0-3.658a1.045 1.045 0 00-1.048 1.04A1.048 1.048 0 0018 6.218a1.048 1.048 0 001.048-1.045A1.045 1.045 0 0018 4.133z" />
      <path d="M34.041 33H1.96a1.956 1.956 0 01-1.959-1.948V1.947A1.955 1.955 0 011.96 0h32.081A1.955 1.955 0 0136 1.947v29.105A1.956 1.956 0 0134.041 33zM1.96 1.574a.375.375 0 00-.376.374v29.105a.376.376 0 00.376.374h32.081a.376.376 0 00.376-.374V1.948a.375.375 0 00-.376-.374z" />
      <path d="M.792 8.57h34.417v1.574H.792zM11.596 19.509H5.635a.789.789 0 01-.792-.787v-5.925a.789.789 0 01.792-.787h5.961a.789.789 0 01.792.787v5.925a.79.79 0 01-.792.787zm-5.169-1.574h4.377v-4.352H6.427zM20.98 19.509h-5.96a.79.79 0 01-.792-.787v-5.925a.789.789 0 01.792-.787h5.96a.788.788 0 01.792.787v5.925a.789.789 0 01-.792.787zm-5.168-1.574h4.376v-4.352h-4.376z" />
      <path
        d="M30.365 19.509h-5.961a.79.79 0 01-.792-.787v-5.925a.789.789 0 01.792-.787h5.961a.789.789 0 01.792.787v5.925a.789.789 0 01-.792.787zm-5.169-1.574h4.377v-4.352h-4.377z"
        sx={{ fill: '#059b9a' }}
      />
      <path d="M11.596 28.893H5.635a.789.789 0 01-.792-.787v-5.924a.789.789 0 01.792-.787h5.961a.789.789 0 01.792.787v5.924a.79.79 0 01-.792.787zm-5.169-1.574h4.377v-4.35H6.427zM20.98 28.893h-5.96a.79.79 0 01-.792-.787v-5.924a.789.789 0 01.792-.787h5.96a.789.789 0 01.792.787v5.924a.789.789 0 01-.792.787zm-5.168-1.574h4.376v-4.35h-4.376z" />
      <path
        d="M27.976 16.552h-1.181a.789.789 0 01-.792-.787.789.789 0 01.792-.787h1.181a.789.789 0 01.792.787.79.79 0 01-.792.787zM30.365 28.889h-5.961a.79.79 0 01-.792-.787v-5.925a.789.789 0 01.792-.787h5.961a.789.789 0 01.792.787v5.925a.789.789 0 01-.792.787zm-5.169-1.574h4.377v-4.352h-4.377z"
        sx={{ fill: '#059b9a' }}
      />
      <path
        d="M27.976 25.932h-1.181a.789.789 0 01-.792-.787.789.789 0 01.792-.787h1.181a.789.789 0 01.792.787.79.79 0 01-.792.787z"
        sx={{ fill: '#059b9a' }}
      />
    </g>
  </React.Fragment>
)

const RoundedCheckMark = (props: GroupProps) => (
  <g transform="translate(-20 -4926)" {...props}>
    <circle
      cx="7.5"
      cy="7.5"
      r="7.5"
      transform="translate(20 4926)"
      fill="#9fd96b"
    />
    <path
      d="M49.456,38.993a31.264,31.264,0,0,0-3.667,6.562,9.794,9.794,0,0,0-1.348-1.962c-.334-.36-1.832-.132-1.345.393a15.706,15.706,0,0,1,2.07,3.466c.191.366,1.356.443,1.5,0a30.535,30.535,0,0,1,4.29-8.252C51.267,38.775,49.771,38.56,49.456,38.993Z"
      transform="translate(-20 4890.244)"
      fill="#0c0636"
    />
  </g>
)

const Save = (props: PathProps) => (
  <path
    d="M5 5v22h22V9.6l-.28-.32-4-4L22.4 5H5zm2 2h3v6h12V7.44l3 3V25h-2v-9H9v9H7V7zm5 0h4v2h2V7h2v4h-8V7zm-1 11h10v7H11v-7z"
    {...props}
  />
)

const Search = (props: PathProps) => (
  <path
    d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
    {...props}
  />
)

const Shield = (props: PathProps) => (
  <path
    d="M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM256.1 446.3l-.1-381 175.9 73.3c-3.3 151.4-82.1 261.1-175.8 307.7z"
    {...props}
  />
)
const Shield2 = () => (
  <React.Fragment>
    <path
      d="M17 30.661a1.034 1.034 0 01-.374-.07c-3.457-1.355-11.5-5.611-11.5-15.846l-.01-7.636a1.019 1.019 0 01.784-.992A48.331 48.331 0 0117 5.01a1.021 1.021 0 011.021 1.019v23.613A1.021 1.021 0 0117 30.661zM7.162 7.919l.009 6.82c0 7.67 5.015 11.525 8.81 13.344V7.055a47.05 47.05 0 00-8.819.864z"
      fill="#068484"
    />
    <path
      d="M17.021 36a1.037 1.037 0 01-.291-.042C13.939 35.131.015 30.229.015 14.795L0 3.444a1.017 1.017 0 01.665-.956C3.54 1.419 8.326-.001 16.675-.001a51.424 51.424 0 0116.636 2.519 1.02 1.02 0 01.69.965l-.01 11.316c0 9.552-5.443 16.6-16.178 20.959l-.4.163a1 1 0 01-.392.079zM2.043 4.158l.015 10.636c0 13.23 10.992 17.874 14.913 19.107l.07-.029c3.687-1.5 14.905-6.048 14.905-19.073l.01-10.581a50.072 50.072 0 00-15.282-2.18c-7.398 0-11.846 1.147-14.631 2.12z"
      fill="#0c0636"
    />
  </React.Fragment>
)
const SignIn = (props: PathProps) => (
  <path
    d="M 6 4 L 6 28 L 26 28 L 26 19 L 24 19 L 24 26 L 8 26 L 8 6 L 24 6 L 24 13 L 26 13 L 26 4 L 6 4 z M 17.5 11 L 13.1875 15.28125 L 12.5 16 L 13.1875 16.71875 L 17.5 21 L 18.90625 19.59375 L 16.3125 17 L 28 17 L 28 15 L 16.3125 15 L 18.90625 12.40625 L 17.5 11 z"
    {...props}
  />
)

const SignInAlt = (props: PathProps) => (
  <path
    d="M-11033.752-10297.535h0a7.539,7.539,0,0,0-7.5,7.5,7.536,7.536,0,0,0,7.5,7.5,7.536,7.536,0,0,0,7.5-7.5A7.539,7.539,0,0,0-11033.752-10297.535Zm4.318,10.707a14.468,14.468,0,0,0-2.388-1.568l-.06-.031v-1.316l.03-.031a1.22,1.22,0,0,0,.333-.842v-1.8a2.052,2.052,0,0,0-2.041-2.039h-.387a2.05,2.05,0,0,0-2.042,2.041v1.795a1.227,1.227,0,0,0,.328.84l.029.031v1.32l-.06.031a14.754,14.754,0,0,0-2.385,1.564,1.273,1.273,0,0,0-.474,1v.413l-.194-.22a6.62,6.62,0,0,1-1.666-4.394,6.659,6.659,0,0,1,1.953-4.7,6.657,6.657,0,0,1,4.688-1.948h.026a6.657,6.657,0,0,1,4.689,1.95,6.663,6.663,0,0,1,1.949,4.7,6.623,6.623,0,0,1-1.662,4.393l-.2.221v-.41A1.257,1.257,0,0,0-11029.434-10286.828Zm-8.266,1a.443.443,0,0,1,.162-.346,14.03,14.03,0,0,1,2.475-1.588.5.5,0,0,0,.281-.451v-1.729a.426.426,0,0,0-.187-.354.38.38,0,0,1-.172-.318v-1.8a1.2,1.2,0,0,1,1.191-1.193h.387a1.2,1.2,0,0,1,1.193,1.193v1.795a.386.386,0,0,1-.174.322.423.423,0,0,0-.187.352v1.73a.508.508,0,0,0,.285.453,13.44,13.44,0,0,1,2.47,1.588.432.432,0,0,1,.161.344v1.148l-.041.033a6.545,6.545,0,0,1-3.889,1.266h-.025a6.553,6.553,0,0,1-3.883-1.268l-.047-.035Z"
    transform="translate(11041.252 10297.535)"
    {...props}
  />
)

const SignUp = (props: PathProps) => (
  <path
    d="M 14 4 C 10.145852 4 7 7.1458513 7 11 C 7 13.408843 8.2311596 15.55212 10.09375 16.8125 C 6.5266132 18.342333 4 21.881262 4 26 L 6 26 C 6 21.569334 9.5693339 18 14 18 C 15.376046 18 16.65445 18.35784 17.78125 18.96875 C 16.671114 20.342565 16 22.103031 16 24 C 16 28.406433 19.593567 32 24 32 C 28.406433 32 32 28.406433 32 24 C 32 19.593567 28.406433 16 24 16 C 22.252849 16 20.630732 16.574679 19.3125 17.53125 C 18.870028 17.253247 18.392372 17.020656 17.90625 16.8125 C 19.76884 15.55212 21 13.408843 21 11 C 21 7.1458513 17.854148 4 14 4 z M 14 6 C 16.773268 6 19 8.2267317 19 11 C 19 13.773268 16.773268 16 14 16 C 11.226732 16 9 13.773268 9 11 C 9 8.2267317 11.226732 6 14 6 z M 24 18 C 27.325553 18 30 20.674447 30 24 C 30 27.325553 27.325553 30 24 30 C 20.674447 30 18 27.325553 18 24 C 18 20.674447 20.674447 18 24 18 z M 23 20 L 23 23 L 20 23 L 20 25 L 23 25 L 23 28 L 25 28 L 25 25 L 28 25 L 28 23 L 25 23 L 25 20 L 23 20 z"
    {...props}
  />
)
const Smile = (props: PathProps) => (
  <path
    d="M16 4C9.38 4 4 9.38 4 16s5.38 12 12 12 12-5.38 12-12S22.62 4 16 4zm0 2c5.53 0 10 4.47 10 10s-4.47 10-10 10S6 21.53 6 16 10.47 6 16 6zm-4.5 6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm9 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-9.69 7L9.1 20a7.98 7.98 0 0 0 13.82 0l-1.72-1a5.98 5.98 0 0 1-10.38 0z"
    {...props}
  />
)

const Spinner = (props: PathProps) => (
  <path
    d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
    {...props}
  />
)

const Star = (props: PathProps) => (
  <path
    d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
    {...props}
  />
)

const Times = (props: PathProps) => (
  <path
    d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
    {...props}
  />
)

const Trash = (props: PathProps) => (
  <path
    d="M15 4c-.52 0-1.06.19-1.44.56-.37.38-.56.92-.56 1.44v1H7v2h1v16c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3V9h1V7h-6V6c0-.52-.19-1.06-.56-1.44A2.04 2.04 0 0 0 19 4h-4zm0 2h4v1h-4V6zm-5 3h14v16a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1V9zm2 3v11h2V12h-2zm4 0v11h2V12h-2zm4 0v11h2V12h-2z"
    {...props}
  />
)

const User = (props: PathProps) => (
  <path
    d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
    {...props}
  />
)

const TwitterSquare = (props: PathProps) => (
  <path
    d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-48.9 158.8c.2 2.8.2 5.7.2 8.5 0 86.7-66 186.6-186.6 186.6-37.2 0-71.7-10.8-100.7-29.4 5.3.6 10.4.8 15.8.8 30.7 0 58.9-10.4 81.4-28-28.8-.6-53-19.5-61.3-45.5 10.1 1.5 19.2 1.5 29.6-1.2-30-6.1-52.5-32.5-52.5-64.4v-.8c8.7 4.9 18.9 7.9 29.6 8.3a65.447 65.447 0 0 1-29.2-54.6c0-12.2 3.2-23.4 8.9-33.1 32.3 39.8 80.8 65.8 135.2 68.6-9.3-44.5 24-80.6 64-80.6 18.9 0 35.9 7.9 47.9 20.7 14.8-2.8 29-8.3 41.6-15.8-4.9 15.2-15.2 28-28.8 36.1 13.2-1.4 26-5.1 37.8-10.2-8.9 13.1-20.1 24.7-32.9 34z"
    {...props}
  />
)

const Warning = (props: PathProps) => (
  <path
    d="M 16 3.21875 L 15.125 4.71875 L 3.125 25.5 L 2.28125 27 L 4 27 L 28 27 L 29.71875 27 L 28.875 25.5 L 16.875 4.71875 L 16 3.21875 z M 16 7.21875 L 26.25 25 L 5.75 25 L 16 7.21875 z M 15 14 L 15 20 L 17 20 L 17 14 L 15 14 z M 15 21 L 15 23 L 17 23 L 17 21 L 15 21 z"
    {...props}
  />
)

const YoutubeSquare = (props: PathProps) => (
  <path
    d="M186.8 202.1l95.2 54.1-95.2 54.1V202.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-42 176.3s0-59.6-7.6-88.2c-4.2-15.8-16.5-28.2-32.2-32.4C337.9 128 224 128 224 128s-113.9 0-142.2 7.7c-15.7 4.2-28 16.6-32.2 32.4-7.6 28.5-7.6 88.2-7.6 88.2s0 59.6 7.6 88.2c4.2 15.8 16.5 27.7 32.2 31.9C110.1 384 224 384 224 384s113.9 0 142.2-7.7c15.7-4.2 28-16.1 32.2-31.9 7.6-28.5 7.6-88.1 7.6-88.1z"
    {...props}
  />
)

export const ICONS = {
  arrowDown: ArrowDown,
  award: Award,
  bars: Bars,
  calendar: Calendar,
  camera: Camera,
  caretDown: CaretDown,
  clap: Clap,
  check: Check,
  'check-mark': CheckMark,
  'chevron-down': ChevronDown,
  'chevron-up': ChevronUp,
  clock: Clock,
  comments: Comments,
  envelope: Envelope,
  expand: Expand,
  'exclamation-circle': ExclamationCircle,
  externalLinkAlt: ExternalLinkAlt,
  eye: Eye,
  'eye-slash': EyeSlash,
  facebookSquare: FacebookSquare,
  file: File,
  'file-text': FileText,
  'file-signed': FileSigned,
  'file-pdf': FilePdf,
  findAStore: FindAStore,
  findMe: FindMe,
  'five-million': FiveMillion,
  frown: Frown,
  'get-more-cash': GetMoreCash,
  heart: Heart,
  'help-center-chevron': HelpCenterChevron,
  home: Home,
  id: IdCard,
  'improve-credit': ImproveCredit,
  infoCircle: InfoCircle,
  key: Key,
  keyboard: Keyboard,
  lightbulb: Lightbulb,
  link: Link,
  locationArrow: LocationArrow,
  lock: Lock,
  mapMarker: MapMarker,
  meh: Meh,
  menu: Menu,
  'money-man': MoneyMan,
  'money-plus': MoneyPlus,
  'money-rocket': MoneyRocket,
  online: Online,
  'pay-off-debt': PayoffDebt,
  passport: Passport,
  phone: Phone,
  'phone-alt': PhoneAlt,
  print: Print,
  question: Question,
  'quote-close': QuoteClose,
  'quote-open': QuoteOpen,
  'repay-over-time': RepayOverTime,
  'rounded-check-mark': RoundedCheckMark,
  save: Save,
  search: Search,
  shield: Shield,
  shield2: Shield2,
  'sign-in': SignIn,
  'sign-in-alt': SignInAlt,
  'sign-up': SignUp,
  smile: Smile,
  spinner: Spinner,
  star: Star,
  times: Times,
  trash: Trash,
  twitterSquare: TwitterSquare,
  user: User,
  warning: Warning,
  youtubeSquare: YoutubeSquare,
  'chevron-right': ChevronRight,
} as const

export type IconName = keyof typeof ICONS

interface IconProps extends SVGAttributes<SVGSVGElement> {
  /**
   * Text to show assistive technologies.
   * **Not** an actual `alt` attribute, because we don't render an `img`, but it serves the same role.
   */
  alt: string
  /** Which Icon to show */
  name: IconName
}

export type IconRef = SVGSVGElement

/**
 * Simple graphics that make an element stand out and increase legibility at a glance.
 */
export const Icon = forwardRef<IconRef, IconProps>(
  (
    {
      name,
      alt,
      width = 32,
      height = 32,
      viewBox = '0 0 512 512',
      fill = '#fff',
      ...rest
    },
    ref
  ) => {
    const Icon = ICONS[name]
    return (
      <Fragment>
        <svg
          ref={ref}
          xmlns="http://www.w3.org/2000/svg"
          width={width}
          height={height}
          viewBox={viewBox}
          focusable="false"
          role="img"
          aria-hidden={alt ? 'false' : 'true'}
          sx={{
            display: 'inline-block',
          }}
          {...rest}
        >
          <Icon sx={{ fill }} />
        </svg>
        <span sx={{ variant: 'visuallyhidden' }}>{alt}</span>
      </Fragment>
    )
  }
)

Icon.displayName = 'Icon'
